export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";